





/* eslint-disable */
// @ts-nocheck
import { defineComponent, useContext } from '@nuxtjs/composition-api';
import { getAsJSON } from '~/utils/solepro/CmsComponentAggregator';
//import { useMemoize } from '@vueuse/core'
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { appendStylesFromText } from '~/utils/solepro/functions';
import { PageBuilderType } from '~/types/solepro/PageBuilder';


export default defineComponent({
  name: 'HTMLContent',
  components: {
    PageBuilderComponent
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    content: {
      type: String | (Object as PropType<PageBuilderType>),
      default: '',
    },
    extractBody: {
      type: Boolean,
      default: false
    },
    alreadyParsed : {
      type: Boolean,
      default: false
    },
    childrenFilter: {
      type: Function,
      default: null
    }

  },
  setup(props) {
    const { content } = props;
    const { isDev, $vsf } = useContext();
    const cmsUrl = $vsf.$magento.config.externalCheckout.cmsUrl
    //const getContentTree = useMemoize(()=>getAsJSON(content)); /**@TODO find how usememoize can work. Now nuxtconfig aliases are not working for vueuse/core :( ) */
    const getContentTree = () => {
      const tree = getAsJSON(content, false, isDev, props.extractBody, cmsUrl);
      if (props.childrenFilter && tree?.children) {
        tree.children = tree.children.filter(props.childrenFilter)
      }
      return tree;
    };
    const contentTree = props.alreadyParsed ? content : getContentTree()

    return {
      getContentTree,
      contentTree
    }
  },
  mounted() {
    if (this.contentTree.pageBuilderStyleNode) appendStylesFromText(this.contentTree.pageBuilderStyleNode)
  }
  /* beforeDestroy(){
     this.getContentTree.clear(); /** Avoid memory leak for storing all the content tree * /
   }*/
});
